<template>
  <div class="certifications">
    <div class="certifications__top-bar">
      <h2 class="certifications__top-bar-title">
        {{ attemptStatusTitle }}
      </h2>
      <p class="certifications__top-bar-subtitle">
        {{ attemptStatusSubTitle }}
      </p>
    </div>
    <div
      v-for="cert in certifications"
      :key="cert.id"
      class="certifications__certification-wrapper"
    >
      <Certification :certification="cert" />
    </div>
  </div>
</template>
<script>
import { intervalToDuration } from 'date-fns'
import { format } from 'date-fns-tz'
import CONSTANTS from '@/constants'
import { hasPassedAttempt } from '@/helpers'
import Certification from './Certification.vue'

export default {
  name: 'Certifications',
  components: {
    Certification,
  },
  props: {
    certifications: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      lastAttempt: null,
    }
  },
  computed: {
    attemptStatusTitle() {
      if (this.everythingIsPassed) {
        return `Congratulations! You've earned the Certification${
          this.certifications?.length > 1 ? 's' : ''
        } associated with this Learning Path!`
      }
      return 'Ready to demonstrate your expertise?'
    },
    attemptStatusSubTitle() {
      let lastAttempt = null
      // many certs not passed
      if (this.certifications?.length > 1 && !this.everythingIsPassed)
        return `This Learning Path has ${this.certifications?.length} certifications available to validate your technical knowledge.`

      if (this.everythingIsPassed) return ''

      if (this.certifications?.length === 1) {
        const cert = this.certifications[0]
        const lastActiveVoucher = cert.user_status?.active_vouchers?.[0]
        const lastInactiveVoucher = cert.user_status?.inactive_vouchers?.[0]
        if (lastActiveVoucher) {
          lastAttempt =
            lastActiveVoucher?.active_attempts?.[0] ||
            lastActiveVoucher?.inactive_attempts?.[0]
          if (
            lastAttempt &&
            lastAttempt.status ===
              CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.IN_PROGRESS
          ) {
            return `This exam is in progress. You have ${this.remainingHours(
              lastAttempt
            )} remaining.`
          }
          if (
            lastAttempt &&
            [
              CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.FINISHED,
              CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.TIMEDOUT,
            ].includes(lastAttempt.status) &&
            !hasPassedAttempt(lastAttempt)
          ) {
            return `You have ${
              lastActiveVoucher.remaining_attempts
            } retakes available until ${this.retakeExpirationShortDate(
              lastActiveVoucher
            )}`
          }
          if (
            lastAttempt &&
            lastAttempt.status ===
              CONSTANTS.CERTIFICATIONS.ATTEMPT_STATUS.REVIEW
          ) {
            return `We're reviewing your exam. You'll get a notification when the results are in.`
          }
          return ''
        }
        return 'You have no available vouchers.'
      }
      return ''
    },
    everythingIsPassed() {
      let hasPassed = true

      this.certifications.map(cert => {
        hasPassed =
          hasPassed &&
          hasPassedAttempt(
            cert.user_status?.inactive_vouchers?.[0]?.inactive_attempts?.[0]
          )
      })
      return hasPassed
    },
  },
  methods: {
    saveLastAttempt() {
      const cert = this.certifications[0]
      this.lastAttempt =
        cert.user_status?.active_vouchers?.[0]?.active_attempts?.[0] ||
        cert.user_status?.active_vouchers?.[0]?.inactive_attempts?.[0] ||
        cert.user_status?.inactive_vouchers?.[0]?.active_attempts?.[0] ||
        cert.user_status?.inactive_vouchers?.[0]?.inactive_attempts?.[0]
    },
    remainingHours(attempt) {
      const duration = intervalToDuration({
        start: new Date(),
        end: new Date(attempt.expiration_date),
      })

      return `${duration.hours}h${duration.minutes}m`
    },
    retakeExpirationShortDate(voucher) {
      return format(
        new Date(voucher.next_attempt_expiration_date),
        'LLL d, yyyy'
      )
    },
  },
  mounted() {
    if (this.certifications?.length === 1) this.saveLastAttempt()
  },
}
</script>
<style lang="scss" scoped>
.certifications {
  color: var(--white);
  &__top-bar {
    width: 100%;
    margin-bottom: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 32px;
      line-height: 38px;
      text-align: center;
      max-width: 1400px;
      margin: 0 auto;
    }
    &-subtitle {
      color: var(--light-blue-gray);
      font-size: 14px;
      line-height: 20px;
      margin: 20px 0px;
      max-width: 240px;
      align-self: center;

      @include mobile {
        max-width: unset;
      }
    }
    &-icon {
      width: 62px;
      height: 50px;
      background-color: var(--black);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
